var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-icon',{staticClass:"fa-override",attrs:{"icon":_vm.icon,"spin":_vm.spin}})
}
var staticRenderFns = []

export { render, staticRenderFns }